import "./SidingCladding.module.css";
import Navigation from "@/reusable_sections/Header";
import SidingHero from "./sections/SidingHero";
import ArchitecturalWallSolutions from "./sections/Solutions";
import Advantage from "./sections/Advantage";
import Solutions from "./sections/Cladding";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function SidingCladdingPage() {
  return <div>
      <Navigation />
      <SidingHero />
      <ArchitecturalWallSolutions />
      <Advantage />
      <Solutions />
      <Consultation />
      <Footer />
    </div>;
}